import { ToggleComponent } from '../../featureToggle';
import ImpressumPageNuttall from '../../customized/alan-nuttall-flexeserve-eu/components/ImpressumPage/ImpressumPage';
import ImpressumPage from './ImpressumPage';

export default ToggleComponent(ImpressumPage, {
  StyledComponentsVariants: {
    'alan-nuttall-flexeserve-eu': ImpressumPageNuttall,
  },
});
